import { all, fork } from "redux-saga/effects";

import HomeSage from "./home/saga";

export default function* rootSaga() {
  yield all([
    fork(HomeSage)
  ]);
};
